import { render, staticRenderFns } from "./GameListPage.vue?vue&type=template&id=2ebeef3e&scoped=true&"
import script from "./GameListPage.vue?vue&type=script&lang=js&"
export * from "./GameListPage.vue?vue&type=script&lang=js&"
import style0 from "./GameListPage.vue?vue&type=style&index=0&id=2ebeef3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebeef3e",
  null
  
)

export default component.exports